import { router, usePage } from '@inertiajs/react';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import type { SharedProps } from '@/types';

interface RefreshGameButtonProps {
  gameId: string;
}

export function RefreshGameButton({ gameId }: RefreshGameButtonProps) {
  const [isLoading, setIsLoading] = useState(false);
  // The refresh is a redirect back to this page, so its outcome arrives as the flash of
  // the page Inertia loaded after it — the server action used to return it inline.
  const { flash } = usePage().props as unknown as SharedProps;
  const message = flash.alert
    ? { text: flash.alert, type: 'error' as const }
    : flash.notice
      ? { text: flash.notice, type: 'success' as const }
      : null;

  const handleRefresh = () => {
    router.post(
      `/25/arcade/submit/review/${gameId}/refresh`,
      {},
      {
        preserveScroll: true,
        onStart: () => setIsLoading(true),
        onFinish: () => setIsLoading(false),
      },
    );
  };

  return (
    <div className="space-y-2">
      <Button
        onClick={handleRefresh}
        disabled={isLoading}
        variant="outline"
        className="w-full border-primary text-primary hover:bg-primary/10"
      >
        {isLoading ? 'Refreshing...' : '🔄 Refresh from Repository'}
      </Button>
      {message && (
        <div
          className={`rounded border-2 px-3 py-2 text-center text-xs ${
            message.type === 'success'
              ? 'border-green-500/50 bg-green-500/5'
              : 'border-red-500/50 bg-red-500/5'
          }`}
        >
          <p
            className={
              message.type === 'success' ? 'text-green-400' : 'text-red-400'
            }
          >
            {message.text}
          </p>
        </div>
      )}
    </div>
  );
}
